import { Link, Text, IconButton, Stack, HStack } from "@chakra-ui/react";
import { FiTwitter } from "react-icons/fi";

export function Footer() {
  return (
    <footer>
      <HStack as="footer" py={2} mt={8} justifyContent="center">
        <Stack align="center" direction="row">
          <Text fontSize="xl" fontWeight="bold">
            copyright{" "}
            <Link href={"https://axenda.io/en"} isExternal prefetch={false}>
              Axenda
            </Link>
          </Text>
        </Stack>
        <Stack as="footer" direction="row" spacing="4">
          <Link href={"https://twitter.com/AxendaTeam/"} isExternal prefetch={false}>
            <IconButton aria-label="Twitter Account" icon={<FiTwitter />} />
          </Link>
        </Stack>
      </HStack>
    </footer>
  );
}
